import { useTranslation } from 'react-i18next';

import { message } from 'antd';

import { useMutation } from '@tanstack/react-query';
import { finishRecovery, startRecovery } from 'api';
import { FinishRecoveryRequest, StartRecoveryRequest } from 'models';
import { useState } from 'react';

interface EmailAuthProps {
  email: string;
  password: string;
}

export default function useForgotPassword() {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  const { mutateAsync: start } = useMutation((data: StartRecoveryRequest) =>
    startRecovery(data),
  );

  const { mutateAsync: finish } = useMutation((data: FinishRecoveryRequest) =>
    finishRecovery(data),
  );

  const requestResetEmail = async ({ email }: { email: string }) => {
    setLoading(true);
    try {
      const result = await start({ login: email });
      return Boolean(result?.success);
    } catch (error: any) {
      message.error(error?.message || t('Something went wrong...'));
      return false;
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async ({ password, token }: FinishRecoveryRequest) => {
    setLoading(true);
    try {
      const result = await finish({ password, token });
      return Boolean(result?.success);
    } catch (error: any) {
      message.error(error?.message || t('Something went wrong...'));
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { requestResetEmail, resetPassword, isLoading };
}
